import { ReviewPageStatePresenter } from '@/presentation/presenters/review/reviewPageStatePresenter'
import { ReviewPageStateViewModel } from '@/presentation/viewmodels/review/reviewPageStateViewModel'

export function useReviewPageStatePresenter(
  presenter: ReviewPageStatePresenter = new ReviewPageStatePresenter(new ReviewPageStateViewModel())
) {
  return {
    isFirstOpendPage: presenter.isFirstOpendPage,
    entrySummaryExpandedList: presenter.entrySummaryExpandedList,
    entrySelectedReviewIndexList: presenter.entrySelectedReviewIndexList,
    isSummaryExpanded: presenter.isSummaryExpanded.bind(presenter),
    isDetailSelected: presenter.isDetailSelected.bind(presenter),
    setIsFirstOpendPage: presenter.setIsFirstOpendPage.bind(presenter),
    setEntrySummaryExpandedFlag: presenter.setEntrySummaryExpandedFlag.bind(presenter),
    setEntrySelectedReviewIndex: presenter.setEntrySelectedReviewIndex.bind(presenter)
  }
}
